import api from '@/api/axios/main.api'

export const fetchDeviceUser = (data) => {
  return api.get(`/api/devices/user/${data.username}`, )
}

export const fetchDeviceAll = (params) => {
  return api.get(`/api/devices/all`, { params })
}
